// extracted by mini-css-extract-plugin
export default {"drawer":"MatchedProductDrawer_drawer__+rLSC"};